import { isProduction } from '../../config/env';

export const HOST = isProduction
  ? 'https://check-ins-check-ins-service-http-prod.hydra.prod.wwrk.co'
  : 'https://check-ins-check-ins-service-http.phoenix.dev.wwrk.co';

export const RESERVATIONS_V1 = `${HOST}/api/v1/reservations`;
export const CHECK_IN_V1 = `${HOST}/api/v1/check-in`;
